export var DriveTypeEnum;
(function (DriveTypeEnum) {
    DriveTypeEnum["FourWheelDrive"] = "FourWheelDrive";
    DriveTypeEnum["TwoWheelDrive"] = "TwoWheelDrive";
    DriveTypeEnum["Unavailable"] = "Unavailable";
})(DriveTypeEnum || (DriveTypeEnum = {}));
export var CarReservationState;
(function (CarReservationState) {
    CarReservationState["Future"] = "Future";
    CarReservationState["Present"] = "Present";
    CarReservationState["Past"] = "Past";
    CarReservationState["Canceled"] = "Canceled";
    CarReservationState["Unused"] = "Unused";
})(CarReservationState || (CarReservationState = {}));
export var CarItineraryResponseEnum;
(function (CarItineraryResponseEnum) {
    CarItineraryResponseEnum["Failure"] = "Failure";
    CarItineraryResponseEnum["Success"] = "Success";
})(CarItineraryResponseEnum || (CarItineraryResponseEnum = {}));
export var ReasonEnum;
(function (ReasonEnum) {
    ReasonEnum["CancellationAttemptFailed"] = "CancellationAttemptFailed";
    ReasonEnum["CancelUserRequest"] = "CancelUserRequest";
    ReasonEnum["CancelRetrieveLongPoll"] = "CancelRetrieveLongPoll";
    ReasonEnum["CancelLongPollRequest"] = "CancelLongPollRequest";
    ReasonEnum["CancellationAttemptOk"] = "CancellationAttemptOk";
    ReasonEnum["BookExtServiceUnavailable"] = "BookExtServiceUnavailable";
    ReasonEnum["BookExtTimeout"] = "BookExtTimeout";
    ReasonEnum["BookExtBadRequest"] = "BookExtBadRequest";
    ReasonEnum["BookExtPriceChanged"] = "BookExtPriceChanged";
    ReasonEnum["BookExtUnavailability"] = "BookExtUnavailability";
    ReasonEnum["CancellationFeesApplicable"] = "CancellationFeesApplicable";
    ReasonEnum["BookProviderUnavailable"] = "BookProviderUnavailable";
})(ReasonEnum || (ReasonEnum = {}));
//# sourceMappingURL=groundItinerary.js.map